<template>
  <div class="tpassDetail tpassDetailReturnHome">
    <loading :show="apiLoading"></loading>
    <!-- 2-1 -->
    <div class="tab-container" v-if="isShowMsg === false">
      <b-tabs fill pills nav-class="tpass-tabs" v-if="!isShowDetails">
        <b-tab title="我要歸戶" :active="changeTab === '1'" @click="clearStep1Data()">
          <validation-observer ref="formObs" slim v-slot="{ handleSubmit }">
            <b-form
              ref="manualForm"
              @submit.prevent="handleSubmit(onUploadFormSubmit)"
              class="formInquire tpass-form"
            >
              <validation-provider
                rules="required|alpha_num"
                v-slot="{ validated, valid, errors }"
                slim
                name="收據號碼"
              >
                <b-form-group
                  label="收據號碼"
                  label-sr-only
                  label-for="inputReceiptNumber"
                  :invalid-feedback="errors[0]"
                >
                  <b-input
                    id="inputReceiptNumber"
                    title="收據號碼"
                    placeholder="請輸入收據號碼，如：ZZ1100000001"
                    v-model="manualFormData.rpPublicNo"
                    :state="validated ? valid : null"
                    autocomplete="off"
                    spellcheck="false"
                  />
                </b-form-group>
              </validation-provider>

              <validation-provider
                rules="required|numeric"
                v-slot="{ validated, valid, errors }"
                slim
                name="檢核碼"
              >
                <b-form-group
                  label="檢核碼"
                  label-sr-only
                  label-for="inputReceiptCode"
                  :invalid-feedback="errors[0]"
                >
                  <b-input
                    id="inputReceiptCode"
                    title="檢核碼"
                    placeholder="請輸入檢核碼，如：9999"
                    v-model.trim="manualFormData.rpPublicRandomCode"
                    :state="validated ? valid : null"
                    autocomplete="off"
                    spellcheck="false"
                  />
                </b-form-group>
              </validation-provider>
            </b-form>
          </validation-observer>
          <!-- 個資聲明 -->
          <personal-info
            @changeMsg="changeMsg"
            @changeAgreement="changeAgreement"
            :reqData="detailData[0]"
            :token="token"
            :isShowBtn="false"
          ></personal-info>
          <div class="personal-info-footer">
            <b-button
              :variant="!agreement ? 'secondary' : 'primary'"
              :disabled="!agreement"
              class="mt-2 mb-5"
              @click="returnHome()"
              >收據歸戶</b-button
            >
          </div>
        </b-tab>
        <b-tab title="已歸戶收據" @click="queryReceipt()" :active="changeTab === '2'">
          <div class="tab-select">
            <div class="col-6 text-center tab-select-item" @click="selectMonthEvent()">
              {{ selecteMonthText }} <i class="fas fa-chevron-down tab-select-down"></i>
            </div>
            <div class="col-6 text-center tab-select-item" @click="selectStatusEvent()">
              {{ selecteStatusText }} <i class="fas fa-chevron-down tab-select-down"></i>
            </div>
          </div>
          <div class="py-4">
            <div class="tab-months" v-for="(item, index) in monthDetailList" :key="`${index}`">
              <div class="month">
                <h5 class="monthText">{{ item[0] }}</h5>
                <div
                  class="date-content d-flex"
                  v-for="(subItem, subindex) in item[1]"
                  :key="`${subindex}`"
                  @click="openTPassDetailContent(subItem, 'getTPassDetailContent')"
                >
                  <div class="date-title">{{ subItem.rpGetDate }}日</div>
                  <div class="date-text">
                    <article class="date-text-content">
                      <div class="date-text-item single-ellipsis">
                        {{ subItem.piName }}
                      </div>
                      <div class="date-text-item">
                        {{ subItem.rpPublicNo }}
                      </div>
                      <div class="date-text-item">${{ subItem.rpRealAmt | currencyFormat }}</div>
                    </article>
                    <div
                      class="date-text-icon date-text-icon-valid"
                      v-if="subItem.rpStatus === '1'"
                    >
                      <i :class="['fas', 'fa-check']" aria-hidden="true"></i>
                    </div>
                    <div
                      class="date-text-icon date-text-icon-invalid"
                      v-if="subItem.rpStatus === '9'"
                    >
                      <i :class="['fas', 'fa-times']" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </div>

    <!-- 情境1-1 查詢收據明細 -->
    <div class="d-lg-none tpass-detail-container" v-if="isShowDetails">
      <tPass-detail-content
        :detailData="detailData"
        :TPassdetailData="TPassdetailData"
        :isShowDetailsAll="isShowDetailsAll"
      ></tPass-detail-content>
    </div>
    <!-- 提示視窗 -->
    <div class="modal-alert" v-if="isShowMsg">
      <t-pass-msg
        ref="tPassMsg"
        @openTPassDetailContent="openTPassDetailContent"
        :TPassdetailData="detailData[0]"
      ></t-pass-msg>
    </div>
    <!-- 下拉選單 -->
    <select-modal
      :title="selectTitle"
      :selectList="selectList"
      :filterType="filterType"
      :monthActiveIdx="monthActiveIdx"
      :statusActiveIdx="statusActiveIdx"
      @changeSelectValue="changeSelectValue"
    ></select-modal>
  </div>
</template>

<script>
import CommonApiMixin from '@/mixins/commonApi';
import ApiMixin from '@/mixins/api';

export default {
  name: 'TpassDetailReturnHome',

  mixins: [CommonApiMixin, ApiMixin],

  data() {
    return {
      detailData: [
        {
          rpStatus: '1',
        },
      ],
      reqData: {},
      apiLoading: false,
      token: null,
      isShowDetails: false,
      isShowMsg: false,
      agreement: false,
      manualFormData: {
        rpPublicNo: '',
        rpPublicRandomCode: '',
      },
      selectList: [],
      selectTitle: '請選擇區間',
      selecteMonthText: '近3個月',
      selecteMonth: '3',
      monthOptions: [
        {
          text: '近3個月',
          value: '3',
        },
        {
          text: '近6個月',
          value: '6',
        },
        {
          text: '近12個月',
          value: '12',
        },
      ],
      monthActiveIdx: 0,
      statusActiveIdx: 0,
      selecteStatusText: '所有狀態',
      selecteStatus: '',
      statusOptions: [
        {
          text: '所有狀態',
          value: '',
        },
        {
          text: '有效',
          value: '1',
        },
        {
          text: '作廢',
          value: '9',
        },
      ],
      receiptStart: this.$moment().local().subtract(3, 'months').format('yyyy-MM-DD 00:00:00.000'),
      receiptEnd: this.$moment().local().format('yyyy-MM-DD 23:59:59.000'),
      monthDetailList: [],
      TPassdetailData: {},
      isShowDetailsAll: true,
      changeTab: '',
      filterType: '', // 查詢條件類別M:月 S:狀態
    };
  },

  created() {
    $('#app, html').css('background-color', '#fff');
    $('#app').css('background-image', 'none');
    $('#app').css('padding-top', '0px');
    $('#global-navbar').css('display', 'none');
    this.token = this.$route.query.token;
    this.reqData.rpPublicNo = this.$route.query.rpPublicNo;
    this.reqData.rpPublicRandomCode = this.$route.query.rpPublicRandomCode;
    // this.QrgetData(this.reqData);
  },

  methods: {
    QrgetData(data) {
      this.$store.commit('api/start');
      this.apiLoading = true;
      const url = '/GovEReceipt/FrontDeskService/FrontDeskService/QueryFNTS';
      const method = 'post';
      this.axiosServiceSend(data, url, method, 'QrgetData');
    },
    returnHome() {
      this.$refs.formObs.validate().then((success) => {
        console.log('success-', success);
        if (success) {
          const url = '/GovEReceipt/FrontDeskService/UpdateTaipeiPass';
          const method = 'post';
          // this.manualFormData.tokenTPass = this.token;
          // this.manualFormData.tokenTPass = 'fromTPITest';
          this.manualFormData.tokenTPass = 'fromTPITest';
          this.axiosServiceSend(this.manualFormData, url, method, 'UpdateTaipeiPass');
        }
      });
    },

    changeMsg(type, message, subMessage, title, options) {
      console.log('測試', type, message, subMessage, title, options);
      this.isShowMsg = true;
      this.$nextTick(() => {
        this.$refs.tPassMsg.changeMsgIcon(type, message, subMessage, title, options);
      });
    },
    changeAgreement(val) {
      this.agreement = val;
    },

    // 已歸戶收據 API
    QueryTaipeiPass(data) {
      this.$store.commit('api/start');
      // eslint-disable-next-line no-param-reassign
      data.tokenTPass = 'fromTPITest';
      this.apiLoading = true;
      const url = '/GovEReceipt/FrontDeskService/QueryTaipeiPass';
      const method = 'post';
      this.axiosServiceSend(data, url, method, 'QueryTaipeiPass');
    },

    // 已歸戶收據 取選單值並打API
    queryReceipt() {
      if (this.selecteMonth === '3') {
        this.receiptStart = this.startDate(3, 'months');
      } else if (this.selecteMonth === '6') {
        this.receiptStart = this.startDate(6, 'months');
      } else if (this.selecteMonth === '12') {
        this.receiptStart = this.startDate(1, 'years');
      }
      const reqData = {
        rpDateStart: this.receiptStart,
        rpDateEnd: this.receiptEnd,
        rpStatus: this.selecteStatus,
        sessionSource: 'H',
      };
      this.QueryTaipeiPass(reqData);
    },

    startDate(num, type) {
      return this.$moment().local().subtract(num, type).format('yyyy-MM-DD 00:00:00.000');
    },

    // 已歸戶收據 分群組
    groupBy(arr, prop) {
      const map = new Map(Array.from(arr, (obj) => [obj[prop], []]));
      arr.forEach((obj) => map.get(obj[prop]).push(obj));
      // return Array.from(map.values());
      return Array.from(map);
    },

    // 已歸戶收據 開內頁明細
    openTPassDetailContent(item, type) {
      this.TPassdetailData = item;
      this.isShowMsg = false;
      console.log('type', type);
      if (type === 'msgGoBack') {
        this.isShowDetails = false;
        this.changeTab = '2';
        this.queryReceipt();
      } else {
        this.isShowDetails = true;
        this.isShowDetailsAll = true;
      }
    },
    // 清除我要歸戶資料
    clearStep1Data() {
      this.manualFormData.rpPublicNo = '';
      this.manualFormData.rpPublicRandomCode = '';
      this.agreement = false;
    },
    selectMonthEvent() {
      this.$bvModal.show('modal-select');
      this.selectTitle = '請選擇區間';
      this.selectList = this.monthOptions;
      this.filterType = 'M';
    },
    selectStatusEvent() {
      this.$bvModal.show('modal-select');
      this.selectTitle = '請選擇狀態';
      this.selectList = this.statusOptions;
      this.filterType = 'S';
    },
    changeSelectValue(data, type, index) {
      if (type === 'M') {
        this.selecteMonth = data.value;
        this.selecteMonthText = data.text;
        this.monthActiveIdx = index;
      } else if (type === 'S') {
        this.selecteStatus = data.value;
        this.selecteStatusText = data.text;
        this.statusActiveIdx = index;
      }
      this.queryReceipt();
      this.$bvModal.hide('modal-select');
    },
    success(type, result) {
      // this.isShow = true;
      switch (type) {
        case 'QrgetData':
          console.log('QrgetData', result);
          if (result.data.object[0].rpStatus === '9') {
            this.isShowMsg = true;
            this.$nextTick(() => {
              this.$refs.tPassMsg.changeMsgIcon('info', '', '此收據已作廢', '');
            });
          } else {
            this.isShowMsg = false;
          }
          this.detailData = result.data.object;
          setTimeout(() => {
            this.apiLoading = false;
          }, 100);
          break;
        case 'UpdateTaipeiPass':
          this.isShowMsg = true;
          this.$nextTick(() => {
            if (result.data.rtnCode === '0000') {
              this.changeMsg('success', result.data.msg, '', '歸戶完成');
            } else if (result.data.rtnCode === '8888') {
              const options = {
                btnName: '查看收據',
                isShowBtn: true,
              };
              this.changeMsg('info', result.data.msg, '', '歸戶錯誤', options);
            } else if (result.data.rtnCode === '9999') {
              this.changeMsg('error', result.data.msg, '', '歸戶失敗');
            } else if (result.data.rtnCode === '7777') {
              this.changeMsg('info', result.data.msg, '', '查無此收據');
            } else if (result.data.rtnCode === '6666') {
              this.changeMsg('info', '', '此收據已作廢', '');
            }
          });
          break;
        case 'QueryTaipeiPass':
          setTimeout(() => {
            this.apiLoading = false;
          }, 100);
          console.log('result.data.object.length', result.data.object.length);
          this.detailData = result.data.object;
          if (result.data.object.length >= 0) {
            this.detailData.forEach((item) => {
              // eslint-disable-next-line no-param-reassign
              item.rpMonth = this.$moment(item.rpDate).format('yyyy年MM月');
              // eslint-disable-next-line no-param-reassign
              item.rpGetDate = this.$moment(item.rpDate).format('DD');
            });
            this.monthDetailList = this.groupBy(this.detailData, 'rpMonth');
            // console.log('this.monthDetailList ', this.monthDetailList);
          }
          // console.log('this.data', this.detailData);
          break;
        default:
          break;
      }
    },
    fail(type, error) {
      switch (type) {
        case 'QrgetData':
          console.log(error);
          break;
        default:
          break;
      }
      this.apiLoading = false;
    },
  },
};
</script>
